import { render, staticRenderFns } from "./ConnectionBanner.vue?vue&type=template&id=3298ffe8&scoped=true"
import script from "./ConnectionBanner.vue?vue&type=script&lang=js"
export * from "./ConnectionBanner.vue?vue&type=script&lang=js"
import style0 from "./ConnectionBanner.vue?vue&type=style&index=0&id=3298ffe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3298ffe8",
  null
  
)

export default component.exports